var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.soldDiffDataLocal
        ? [
            _c(
              "v-popover",
              { attrs: { "auto-hide": true } },
              [
                _c("div", [
                  _c(
                    "span",
                    {
                      class: {
                        "badge pointer": true,
                        "badge-danger":
                          _vm.soldDiffDataLocal.last_sold_rate >
                          _vm.soldDiffDataLocal.preset_sold_rate,
                        "badge-success":
                          _vm.soldDiffDataLocal.last_sold_rate <=
                          _vm.soldDiffDataLocal.preset_sold_rate,
                      },
                    },
                    [_vm._v(_vm._s(_vm.soldDiffDataLocal.last_sold_rate))]
                  ),
                  _vm._v("\n        |\n        "),
                  _c(
                    "span",
                    {
                      class: {
                        "badge pointer": true,
                        "badge-danger":
                          _vm.soldDiffDataLocal.last_sold_rate >
                          _vm.soldDiffDataLocal.preset_sold_rate,
                        "badge-success":
                          _vm.soldDiffDataLocal.last_sold_rate <=
                          _vm.soldDiffDataLocal.preset_sold_rate,
                      },
                    },
                    [_vm._v(_vm._s(_vm.soldDiffDataLocal.preset_sold_rate))]
                  ),
                ]),
                _vm._v(" "),
                _c("template", { slot: "popover" }, [
                  _c("p", [
                    _vm._v(
                      "продажи за " +
                        _vm._s(_vm.soldDiffDataLocal.days) +
                        " дней"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(_vm._s(_vm.soldDiffDataLocal.total_qty) + " / "),
                    _c("strong", [
                      _vm._v(_vm._s(_vm.soldDiffDataLocal.last_sold_rate)),
                    ]),
                    _vm._v(" в день"),
                  ]),
                  _vm._v(" "),
                  _c("hr", { staticClass: "m-1" }),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "продажи с " +
                        _vm._s(
                          _vm.printDate(
                            _vm.soldDiffDataLocal.start_date,
                            "DD.MM.YYYY"
                          )
                        )
                    ),
                  ]),
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.soldDiffDataLocal.present_sold) +
                      " / "
                  ),
                  _c("strong", [
                    _vm._v(_vm._s(_vm.soldDiffDataLocal.preset_sold_rate)),
                  ]),
                  _vm._v(" в день\n      "),
                ]),
              ],
              2
            ),
          ]
        : [_vm._v("\n    loading...\n  ")],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }